import Storages from "../helper/storages"

var InitUserInfo = (userInfo) => {

    Storages.setUserToken(userInfo.token)

    Storages.setExtendedTokenTime(userInfo.extendedTime)
    if(userInfo.refreshTime<10){
        Storages.setRefreshTime(10)
    }else{
        Storages.setRefreshTime(userInfo.refreshTime)
    }
    Storages.setUserInfo(userInfo)
    
}

export default InitUserInfo